import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Rating } from 'primereact/rating';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { ProductService } from '../ProdcutService';
import GetRequest from '../../../service/GetRequest';
import { Dropdown } from 'primereact/dropdown';
import { SplitButton } from 'primereact/splitbutton';
import { Skeleton } from 'primereact/skeleton';
import { Dialog } from 'primereact/dialog';


const OrderListByProductsTable = () => {
    const [products, setProducts] = useState([]);
    const [expandedRows, setExpandedRows] = useState(null);
    const [orderDetailsLoading, setOrderDetailsLoading] = useState(true);
    const [orderDetailsPopupVisible,setOrderDetailsPopupVisible] = useState(false);

    const toast = useRef(null);

    const [branchList, setBranchList] = useState([]);
    const [selectedBranchId, setSelectedBranchId] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState({});


    useEffect(() => {
        if (selectedBranch.id) {
            console.log("branchId changed");
        }
    }, [selectedBranch]);

    useEffect(() => {
        setOrderDetailsLoading(true);
        fetchStoreDetails();
    }, []);

    const fetchStoreDetails = () => {
        setOrderDetailsLoading(true);
        GetRequest("v1/store-management-service/view/my/store", true)
            .then(response => {
                if (!response || !response.storeBranches || response.storeBranches.length === 0) {
                    console.error("Empty response or undefined data for store branches");
                } else {
                    setBranchList(response.storeBranches);
                    setSelectedBranch(response.storeBranches[0]); // Select the first branch by default
                    setSelectedBranchId(response.storeBranches[0].id); // Select the first branch ID by default
                    setOrderDetailsLoading(false);
                }
            })
            .catch(error => {
                console.error("Error fetching store details:", error);
                setOrderDetailsLoading(false);
            });
    };

    const handleBranchChange = (e) => {
        const selectedBranch = branchList.find(branch => branch.id === e.value);
        setSelectedBranch(selectedBranch);
        setSelectedBranchId(e.value);
        console.log("selected branch city:", selectedBranch.city);
        console.log("Selected branch:", e.value);
    };


    useEffect(() => {
        if (selectedBranchId) {
            ProductService.getProductsWithOrdersSmall(selectedBranchId).then((data) => setProducts(data));
        }
    }, [selectedBranchId]);


    const buttonOptions = [
        {
            label: 'Update',
            icon: 'pi pi-refresh',
            command: () => {
                toast.current.show({ severity: 'success', summary: 'Updated', detail: 'Data Updated' });
            }
        },
        {
            label: 'Message',
            icon: 'pi pi-envelope',
            command: () => {
                toast.current.show({ severity: 'success', summary: 'Updated', detail: 'Data Updated' });
            }
        },
        {
            label: 'Track',
            icon: 'pi pi-truck',
            command: () => {
                toast.current.show({ severity: 'warn', summary: 'Delete', detail: 'Data Deleted' });
            }
        },
        {
            label: 'Cancel Order',
            icon: 'pi pi-times-circle',
            command: () => {
                toast.current.show({ severity: 'warn', summary: 'Delete', detail: 'Data Deleted' });
            }
        },
        {
            label: 'Refund',
            icon: 'pi pi-credit-card',
            command: () => {
                window.location.href = 'https://reactjs.org/';
            }
        },
    ];

    const viewOrder = () => {
        setOrderDetailsPopupVisible(true);
    };


    const onRowExpand = (event) => {
        toast.current.show({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
    };

    const onRowCollapse = (event) => {
        toast.current.show({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
    };

    const expandAll = () => {
        let _expandedRows = {};

        products.forEach((p) => (_expandedRows[`${p.id}`] = true));

        setExpandedRows(_expandedRows);
    };

    const collapseAll = () => {
        setExpandedRows(null);
    };

    const orderedAmountBodyTemplate = (rowData) => {
        return <div className="flex flex-col space-y-1">
        <div className="flex items-center space-x-2">
            Quantity :
            <span>{rowData.quantity}</span>
        </div>
        <div className="flex items-center space-x-2">
            purchase Rate: £
            <span>{rowData.purchaseRate}</span>
        </div>
    </div>;
    };

    const customerBodyTemplate = (rowData) => {
        return <div className="flex flex-col space-y-1">
        <div className="flex items-center space-x-2">
            <i className="pi pi-user"></i>
            <span>{rowData.customerFullName}</span>
        </div>
        <div className="flex items-center space-x-2">
            <i className="pi pi-envelope"></i>
            <span>{rowData.customerEmail}</span>
        </div>
    </div>
    };

    const statusOrderBodyTemplate = (rowData) => {
        return <Tag value={rowData.orderStatus.toLowerCase()} severity={getOrderSeverity(rowData)}></Tag>;
    };

    const searchBodyTemplate = () => {
        return <SplitButton label="View" icon="pi pi-eye" onClick={viewOrder} model={buttonOptions} />;
    };

    const imageBodyTemplate = (rowData) => {
        return <img src={`data:image/jpeg;base64,${rowData.productImage}`} alt={rowData.productImage} width="64px" className="shadow-4" />;
    };

    const priceBodyTemplate = (rowData) => {
        return "£"+rowData.sellingPrice;
    };

    const ratingBodyTemplate = (rowData) => {
        return <Rating value={rowData.rating} readOnly cancel={false} />;
    };

    const statusBodyTemplate = (rowData) => {
        return <Tag value={rowData.inventoryStatus} severity={getProductSeverity(rowData)}></Tag>;
    };

    const getProductSeverity = (product) => {
        switch (product.inventoryStatus) {
            case 'INSTOCK':
                return 'success';
            case 'LOWSTOCK':
                return 'warning';
            case 'OUTOFSTOCK':
                return 'danger';
            default:
                return null;
        }
    };

    const getOrderSeverity = (order) => {
        switch (order.orderStatus) {
            case 'DELIVERED':
                return 'success';
            case 'CANCELLED':
                return 'danger';
            case 'PENDING':
                return 'warning';
            case 'RETURNED':
                return 'info';
            default:
                return null;
        }
    };

    const allowExpansion = (rowData) => {
        return rowData.orderDetails && rowData.orderDetails.length > 0;
    };

    const rowExpansionTemplate = (data) => {
        return (
            <div className="p-3">
                <h5>Orders for {data.name}</h5>
                <DataTable value={data.orderDetails}>
                    <Column field="orderId" header="orderId" sortable></Column>
                    <Column field="customerFullName" header="Customer" body={customerBodyTemplate} sortable></Column>
                    <Column field="orderDate" header="Date" sortable></Column>
                    <Column field="purchaseRate" header="Amount" body={orderedAmountBodyTemplate} sortable></Column>
                    <Column field="inventoryStatus" header="Status" body={statusOrderBodyTemplate} sortable></Column>
                    <Column headerStyle={{ width: '4rem' }} body={searchBodyTemplate}></Column>
                </DataTable>
            </div>
        );
    };

    const header = (
        <div className="flex flex-wrap justify-content-end gap-2">
             <Dropdown
                value={selectedBranchId}
                options={branchList.map(branch => ({ label: branch.city, value: branch.id }))}
                onChange={handleBranchChange}
                optionLabel="label"
                placeholder="Select a Branch"
                className="w-full md:w-14rem"
                checkmark={true} 
                highlightOnSelect={false}
            />
            <Button icon="pi pi-plus" label="Expand All" onClick={expandAll} text />
            <Button icon="pi pi-minus" label="Collapse All" onClick={collapseAll} text />
        </div>
    );

    return (
        <div className="card">
            <Toast ref={toast} />
            {orderDetailsLoading ? (
                <div className="mt-30">
                    <Skeleton width="100%" height="500px" className="col-12 mb-3"></Skeleton>
                </div>
            ) :
            <DataTable
                value={products}
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
                onRowExpand={onRowExpand}
                onRowCollapse={onRowCollapse}
                rowExpansionTemplate={rowExpansionTemplate}
                dataKey="itemId"
                header={header}
                tableStyle={{ minWidth: '60rem' }}
            >
           

                <Column header="Actions"expander={allowExpansion} style={{ width: '5rem' }} />
                <Column field="name" header="Name" sortable />
                <Column header="Image" body={imageBodyTemplate} />
                <Column field="price" header="Price" sortable body={priceBodyTemplate} />
                <Column field="category" header="Category" sortable />
                <Column field="rating" header="Reviews" sortable body={ratingBodyTemplate} />
                <Column field="inventoryStatus" header="Status" sortable body={statusBodyTemplate} />
            </DataTable>}

            <Dialog header="Header" visible={orderDetailsPopupVisible} style={{ width: '50vw' }} onHide={() => {if (!orderDetailsPopupVisible) return; setOrderDetailsPopupVisible(false); }}>
                <p className="m-0">
                    Order details
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
                    Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
        </Dialog>
        </div>
    );
};

export default OrderListByProductsTable;
